export const CUSTOMIZE_OFFERS = 'CUSTOMIZE_OFFERS';
export const CUSTOMIZE_OFFERS_PENDING = `${CUSTOMIZE_OFFERS}_PENDING`;
export const CUSTOMIZE_OFFERS_FAILED = `${CUSTOMIZE_OFFERS}_FAILED`;
export const CUSTOMIZE_OFFERS_SUCCESS = `${CUSTOMIZE_OFFERS}_SUCCESS`;
